import { stringifyGraph } from '@/clients/http'
import { CategoryModel } from '@/http/models/ProductCategory'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { ProductCategoryHttpParams, ProductCategoryModel, ProductCategoryResponses } from '@/types'

export interface CategoryListFilters {
  search?: string
  status?: 'active' | 'inactive' | null
}

export interface CategoryListForm extends UseFetchListForm<
  CategoryListFilters,
  ProductCategoryModel.ProductCategory
> {}

interface UseFetchCategoriesProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const categoryInitialFilters: CategoryListFilters = {
  search: '',
  status: null,
}

export const useFetchCategories = ({ sort, shouldFetchList }: UseFetchCategoriesProps) => {
  return useFetchList<
    CategoryListFilters,
    ProductCategoryModel.ProductCategory,
    {},
    any,
    typeof CategoryModel.getList
  >({
    pageSize: 10,
    initialFilters: categoryInitialFilters,
    fetchFunction: CategoryModel.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<ProductCategoryHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      status: filters.status || undefined,
      graph_enc: stringifyGraph({
        '*': true,
        parent: {
          name: true,
        },
        image: {
          path: true,
          versions: true,
        },
        'products.count': true,
      }),
    }),
    buildParams: () => ({}),
  })
}
